import clsx from "clsx";
import { NavLink } from "react-router-dom";

import type { ReactNode } from "react";

interface MobileNavigationTabsProps {
  navItems: (
    | {
        label: string;
        path: string;
        subNavItems?: { label: string; path: string }[];
        mobileSeparator?: boolean;
        end?: boolean;
      }
    | { element: ReactNode }
  )[];
  className?: string;
}

function getTabClassName(isActive: boolean, mobileSeparator?: boolean) {
  return clsx(
    "flex py-3 px-6 text-button-md items-center transition-[color,background] text-nowrap border-b",
    mobileSeparator && "border-l border-l-black-200",
    isActive
      ? "text-black-950 border-b-black-950"
      : "text-black-400 border-b-transparent",
  );
}

export default function MobileNavigationTabs({
  navItems,
  className,
}: MobileNavigationTabsProps) {
  return (
    <div
      className={clsx(
        "flex border-b border-b-black-200 overflow-y-auto",
        className,
      )}
    >
      {navItems.map((item) => {
        if ("element" in item) {
          return item.element;
        }
        const { subNavItems, label, path, mobileSeparator } = item;
        if (subNavItems) {
          return (
            <>
              {subNavItems.map((subNavItem, subNavIndex) => (
                <NavLink
                  to={subNavItem.path ? `${path}/${subNavItem.path}` : path}
                  key={`${path}-${subNavItem.path}`}
                  end
                  className={({ isActive }) =>
                    getTabClassName(
                      isActive,
                      mobileSeparator && subNavIndex === 0,
                    )
                  }
                >
                  {subNavItem.label} {label}
                </NavLink>
              ))}
            </>
          );
        }
        return (
          <NavLink
            to={path}
            key={label}
            end={item.end ?? true}
            className={({ isActive }) =>
              getTabClassName(isActive, mobileSeparator)
            }
          >
            {label}
          </NavLink>
        );
      })}
    </div>
  );
}
